import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import Text from "./text/Text";
import CommonSkeleton from "./CommonSkeleton";
import { prepareTabDataInOrder } from "./constants";

function SelectionTabs({
  data,
  handleAction,
  selectedTab,
  textSize,
  lastSelected,
  currencyColor,
  setSelectedAsset,
}) {
  const sliderRef = useRef();

  const [preparedData, setPreparedData] = useState([]);

  useEffect(() => {
    if (data.length) {
      const resultData = prepareTabDataInOrder(data);
      setPreparedData(resultData);
      let index = -1;
      const result = resultData?.find((asset, i) => {
        if (asset?.uuid === lastSelected) {
          index = i;
          return true;
        }
        return false;
      });
      setSelectedAsset(result);
      sliderRef.current?.slickGoTo(index);
    }
  }, [data]);

  const tabLoaderCss = {
    borderRadius: "10px",
    width: "48%",
    height: "43px",
    sx: { transform: "scale(1, 1)", margin: "10px 0 10px" },
  };

  return preparedData?.length <= 0 ? (
    <Box className="tabs-container">
      <CommonSkeleton {...tabLoaderCss} />

      <CommonSkeleton {...tabLoaderCss} />
    </Box>
  ) : (
    <Box className="tabs-container">
      {preparedData?.length > 0 &&
        preparedData?.map((tab) => {
          return (
            <Box
              className={
                selectedTab === tab?.uuid
                  ? `selected-tab ${currencyColor}`
                  : "lightning-onchain-tab"
              }
              onClick={() => {
                handleAction(tab?.uuid);
              }}
              padding="10px 14px"
              margin="12px 0px"
              key={tab?.uuid}
            >
              <Text
                size={textSize}
                font="semibold"
                className="default-class tab-content"
              >
                <img
                  src={tab?.icon}
                  height="24px"
                  width="24px"
                  style={{ marginBottom: "4px" }}
                  alt="payment method icon"
                />
                {tab?.name}
              </Text>
            </Box>
          );
        })}
    </Box>
  );
}

export default React.memo(SelectionTabs);
